/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { ContainerStowageLocationDto } from '../model'
/**
 * ContainerStowageLocationsApi - axios parameter creator
 */
export const ContainerStowageLocationsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/ContainerStowageLocations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ContainerStowageLocationsApi - functional programming interface
 */
export const ContainerStowageLocationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ContainerStowageLocationsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerStowageLocationDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(carrierVisitId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ContainerStowageLocationsApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ContainerStowageLocationsApi - factory interface
 */
export const ContainerStowageLocationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ContainerStowageLocationsApiFp(configuration)
  return {
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ContainerStowageLocationDto>> {
      return localVarFp.get(carrierVisitId, options).then(request => request(axios, basePath))
    },
  }
}

/**
 * ContainerStowageLocationsApi - object-oriented interface
 */
export class ContainerStowageLocationsApi extends BaseAPI {
  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(carrierVisitId?: number, options?: RawAxiosRequestConfig) {
    return ContainerStowageLocationsApiFp(this.configuration)
      .get(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
